module.exports = __webpack_public_path__ + "static/media/Flaticon.1fdbdc4d.woff2";